import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModuleInfo } from 'sharedModels/module-info';
import { DynamicControlDirective } from 'sharedGlobals/dynamic-component/dynamic-control.directive';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { QuoteDynamicPageComponent } from './quote-dynamic-page.component';

@Component({
    selector: 'lib-dynamic-page-controller',
    templateUrl: './html/dynamic-page.component.html',
    styleUrls: ['./css/dynamic-page.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DynamicControlDirective, NgxSkeletonLoaderModule],
})
export class VirsekerDynamicPageComponent extends QuoteDynamicPageComponent {
    getModuleLoader = (moduleInfo: ModuleInfo) => {
        return this.getVirsekerModule(moduleInfo);
    };

    /**
     * Virseker specific Module Map - lazy loaded modules using function wrappers
     * Each property contains a function that returns a Promise, ensuring modules are only
     * imported when getVirsekerModule is called, not during component initialization.
     */
    moduleMap: Record<string, () => Promise<any>> = {
        StaticModule: () =>
            import('../../../modules/static/virseker-static.module').then(
                (m) => m.VirsekerStaticModule,
            ),
        CarDetailsModule: () =>
            import('../../../modules/car-details/virseker-car-details.module').then(
                (m) => m.VirsekerCarDetailsModule,
            ),
        PersonalDetailsModule: () =>
            import('../../../modules/personal-details/virseker-personal-details.module').then(
                (m) => m.VirsekerPersonalDetailsModule,
            ),
        QuoteDetailsModule: () =>
            import('../../../modules/quote-details/virseker-quote-details.module').then(
                (m) => m.VirsekerQuoteDetailsModule,
            ),
        BuildCoverDetailsModule: () =>
            import('../../../modules/build-cover-details/virseker-build-cover-details.module').then(
                (m) => m.VirsekerBuildCoverDetailsModule,
            ),
        FinaliseDetailsModule: () =>
            import('../../../modules/finalise-details/virseker-finalise-details.module').then(
                (m) => m.VirsekerFinaliseDetailsModule,
            ),
        CashbackModule: () =>
            import('../../../modules/cashback-details/virseker-cashback.module').then(
                (m) => m.VirsekerCashbackModule,
            ),
        PolicyCancellationModule: () =>
            import('../../../modules/policy-cancellation/virseker-policy-cancellation.module').then(
                (m) => m.VirsekerPolicyCancellationModule,
            ),
        ResumeQuoteModule: () =>
            import('../../../modules/resume-quote/virseker-resume-quote.module').then(
                (m) => m.VirsekerResumeQuoteModule,
            ),
        HomeContentsDetailsModule: () =>
            import(
                '../../../modules/home-content-details/virseker-home-content-details.module'
            ).then((m) => m.VirsekerHomeContentDetailsModule),
        IncidentDetailsModule: () =>
            import('../../../modules/incident-details/virseker-incident-details.module').then(
                (m) => m.VirsekerIncidentDetailsModule,
            ),
    };

    getVirsekerModule = async (moduleInfo: ModuleInfo) => {
        const importFunction = this.moduleMap[moduleInfo.moduleName];
        return importFunction ? await importFunction() : undefined;
    };
}
